import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chat from "./components/Chat/Chat";
import CookieConsentBanner from "./components/CookieConsent/CookieBanner";
import { useCookies } from "react-cookie";

const Layout = ({ children }) => {
  const location = useLocation();

  const [cookies] = useCookies(["cookie_consent", "analytics"]);

  useEffect(() => {
    if (
      cookies.analytics === "true" &&
      typeof window.gtag === "function" &&
      !window.cookieConsentAnalyticsDisabled
    ) {
      window.gtag("config", "G-ZZ8GCQ27TZ", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search, cookies.analytics]);
  const isAdminPanel = useMemo(
    () => location.pathname.startsWith("/admin"),
    [location.pathname]
  );

  const showChat = useMemo(() => {
    const consentValues = ["true", "all", "custom", "necessary"];
    return !isAdminPanel && consentValues.includes(cookies.cookie_consent);
  }, [isAdminPanel, cookies.cookie_consent]);

  return (
    <>
      <div className="relative">
        {!isAdminPanel && <Navbar />}
        {children}
        {!isAdminPanel && <Footer />}
      </div>

      {showChat && <Chat />}
      {!isAdminPanel && <CookieConsentBanner />}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
